







































import { Component, mixins } from '@niknevis/vue-modules'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import { InjectReactive, Prop } from 'vue-property-decorator'
import { BasicCampaignCollectionType } from '@/modules/base-campaign/models/base-campaign-collection.model'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import DateTooltippedTableCell from '@/modules/shared/components/panel/DateTooltippedTableCell.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import ContentCampaignStatusView from '@/modules/content-campaign/components/shared/ContentCampaignStatusView.vue'
import ContentCampaignItemsCountByStatus
  from '@/modules/content-campaign/components/shared/ContentCampaignItemsCountByStatus.vue'

@Component({
  components: { ContentCampaignStatusView, BaseButton, TextEllipsis, TesTd, TesTr }
})
export default class PanelLastCampaignTableRow extends mixins<TesTableRow>(TesTableRow) {

  @Prop() row!: any

  @InjectReactive()
  lastCampaigns!: BasicCampaignCollectionType

  get withData() {
    return {
      content_statuses: this.lastCampaigns.content_statuses
    }
  }

  columnComponents = {
    items_count: {
      component: ContentCampaignItemsCountByStatus,
      handler: (value, row) => ({
        items_count: value,
        total_counts: row.total_items_count
      })
    },
    created_at: DateTooltippedTableCell,
    running_at: DateTooltippedTableCell
  }


}
